import { IonContent } from '@ionic/react';
import ModalWrapper from '../../components/modals/ModalWrapper';
import { FC, ReactNode } from 'react';
import { IModal } from '../../router/ModalRouter';
import { CouponDetailsInterface } from '../../../../services/exports/Interfaces';
import DefaultMultiPromoCodeModal from '../../../../modals/MultiPromoCodeModal';
import useModalRouter from '../../common/hooks/useModalRouter';

interface Props {
  /** The promo to show in PREVIEW when opened from a card (not yet applied). */
  previewPromoCode?: CouponDetailsInterface | null;
}

// Native-style Ion modal wrapper for the multi-promo-code breakdown — mirrors `offer-modal`.
// Presented by the mobile `ModalRouter`/`ModalRoute` as an `IonModal` sheet, which respects the
// device safe areas natively (the generic web `CustomModal` did not — FOO-3200).
const MultiPromoCode: FC<Partial<IModal> & Props> = (props): ReactNode => {
  const { closeModal } = useModalRouter();

  return (
    <ModalWrapper>
      {/* min-h gives the auto-height Ion sheet a real height (mirrors offer-modal); without it the
          sheet collapses to a blank sliver at the bottom of the screen — FOO-3200. */}
      <IonContent className="min-h-[90dvh]">
        {/* Wrap closeModal so no argument is forwarded: the modal wires `toggleModal` straight to
            onClick handlers, and the router's closeModal(id?) would otherwise treat the click event
            as a mismatched id and refuse to close (mirrors how offer-modal calls props.onClose()). */}
        <DefaultMultiPromoCodeModal
          openModal
          toggleModal={() => closeModal()}
          previewPromoCode={props.previewPromoCode}
        />
      </IonContent>
    </ModalWrapper>
  );
};

export default MultiPromoCode;
